import {eraseCookie, getToken} from "../utils";
import { Navigate } from 'react-router-dom';
import React, { useRef } from "react";
import { useQuery } from 'react-query';
import { getMyProfile} from "../api/requests";
import FullScreenLoader from "./FullScreenLoader";

function FetchGlobalData({ children}:any){
  useQuery(["profile"],()=>getMyProfile());
  return children
}
/**
 * Default access based on token availability
 * @param {*} props { children }
 * @returns
 */
export function Secured({ children } : any)  {


  let tokenFromLocalStorage = localStorage.getItem('token');
  let authenticated = false;
  const token:any= getToken();


  if(!!tokenFromLocalStorage){
    authenticated = true;
  }
  if(token !== "null"){
    authenticated = true
    localStorage.setItem('token', token);
    eraseCookie('authtoken');
  }
  else {
    localStorage.removeItem('token');
    authenticated = false;
  }


  if (!authenticated) {
    localStorage.removeItem('token');
    window.location.href = '/auth/login'
  }
    
  
  return !authenticated ? <FullScreenLoader />: <FetchGlobalData><React.Fragment>{children}</React.Fragment></FetchGlobalData> 


}
